module.exports = __webpack_public_path__ + "media/images/gallery/gc_tab_on-2a699565340b121d8779de9a7efc610d.jpg";